import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const LINKS = [
  { label: "Établissements", href: "#etablissements", id: "etablissements" },
  { label: "Pros du bien-être", href: "#pros", id: "pros" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-[70]"
    >
      <div
        className={`transition-all duration-500 ${
          scrolled ? "glass border-b border-white/40" : "bg-transparent border-b border-transparent"
        }`}
      >
        <nav className="wrap flex items-center justify-between py-4 md:py-5">
          <a
            href="#top"
            onClick={(e) => go(e, "#top")}
            data-testid="nav-logo"
            className="leading-none"
          >
            <span className="font-display font-semibold text-lg md:text-xl tracking-tight">
              Douceur Power <span className="font-serifit italic font-normal">Prod</span>
            </span>
            <span className="block eyebrow !text-[0.55rem] opacity-50 mt-1">
              Studio de production wellness
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-9">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                data-testid={`nav-link-${l.id}`}
                className="group relative text-[0.82rem] font-semibold tracking-wide uppercase opacity-70 hover:opacity-100 transition-opacity"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-[#FF4B3E] transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
          </div>

          <a
            href="mailto:alexia@ommymind.org?subject=Projet"
            data-testid="nav-cta"
            className="btn btn-ink !py-3 !px-6 text-[0.8rem]"
          >
            Nous écrire
            <ArrowUpRight size={15} strokeWidth={2.5} />
          </a>
        </nav>
      </div>
    </motion.header>
  );
}
